import { aboutInfo } from '@/mocks/homeMocks';

export default function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6 scroll-mt-20">
              {aboutInfo.title}
            </h2>
            <div className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8 space-y-4">
              {aboutInfo.content.split('\n\n').map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
            </div>
            <div className="flex items-center justify-center gap-8 md:gap-12">
              {aboutInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl text-primary-500 whitespace-nowrap">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-600 mt-1 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}